import { useState } from 'react';

interface Preset {
  label: string;
  description: string;
  apply: () => void;
}

interface ScenarioPresetsProps {
  presets: Preset[];
}

export function ScenarioPresets({ presets }: ScenarioPresetsProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6">
      <span className="text-[10px] font-mono text-outline uppercase tracking-wider shrink-0">Try a scenario:</span>
      {presets.map((preset, i) => (
        <button
          key={preset.label}
          type="button"
          title={preset.description}
          onClick={() => { setActiveIndex(i); preset.apply(); }}
          className="text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 border rounded-sm transition-colors"
          style={
            activeIndex === i
              ? { borderColor: '#0078d4', backgroundColor: 'rgba(0,120,212,0.10)', color: '#0078d4' }
              : { borderColor: 'var(--outline-variant)', color: 'var(--text-tertiary)' }
          }
        >
          {preset.label}
        </button>
      ))}
    </div>
  );
}
